import { Component, Input } from '@angular/core';
import { ReportsService } from "../reports.service";
import { FileSaverService } from "../../shared/file-saver.servive";
import { ReportTypes } from '../reports.enum';
import { FileType } from '../../shared/filetype.enum';

@Component({
    moduleId: module.id,
    selector: 'phone-plan-breakdown-report',
    templateUrl: 'phone-plan-breakdown-report.component.html'
})

export class PhonePlanBreakdownReportComponent {
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() fileName: string;
    disableCsvButton: boolean = false;
    disableExcelButton: boolean = false;

    constructor(
        private reportsService: ReportsService,
        private fileSaverService: FileSaverService) { }

    downloadCsv(event: any) {
        event.preventDefault();
        this.disableCsvButton = true;
        let fileName = `${this.fileName} Phone Plan Breakdown`;
        let file = `${fileName}.csv`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.PhonePlanBreakdown, FileType.Csv).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableCsvButton = false; }
        );
    }

    downloadExcel(event: any) {
        event.preventDefault();
        this.disableExcelButton = true;
        let fileName = `${this.fileName} Phone Plan Breakdown`;
        let file = `${fileName}.xlsx`;
        this.reportsService.generateReportFile(this.startDate, this.endDate, fileName, ReportTypes.PhonePlanBreakdown, FileType.Excel).subscribe(
            (data: Blob) => this.fileSaverService.downloadFile(data, file),
            () => { },
            () => { this.disableExcelButton = false; }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/reports/phone-plan-breakdown-report/phone-plan-breakdown-report.component.ts